/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-04-10T08:00:58.771Z by lizhutang (lizhutang@spolo.org)

'use strict'

const dataLoadingImg = 'data-loading-img'
const dataNoLazysizes = 'data-nolazysizes'
const b64starter = 'data:image/'
function procElement ($content, buildInfo) {
  if (!$content) {
    return
  }
  $content.find('img').each(function () {
    let $this = $(this)
    let src = $this.attr('src')
    // 以base64内容做编码的img或者明确指明不lazy化的img，不做lazysizes处理。
    if ((typeof src === 'string' && src.startsWith(b64starter)) || (this.hasAttribute(dataNoLazysizes) && $this.attr(dataNoLazysizes))) {
      $this.removeAttr(dataNoLazysizes)
      $this.removeAttr(dataLoadingImg)
    } else {
      $this.removeAttr(dataNoLazysizes)
      let srcset = $this.attr('srcset')
      if (src) {
        $this.attr('data-src', src)
        $this.removeAttr('src')
      }
      if (srcset) {
        $this.attr('data-srcset', srcset)
        $this.removeAttr('srcset')
      }
      if ((!$this.attr('width') || !$this.attr('height')) && !$this.attr('data-sizes')) {
        $this.attr('data-sizes', 'auto')
      }
      if ($this.attr('alt')) { // 为防止闪烁，将alt改为data-alt。
        $this.attr('data-alt', $this.attr('alt'))
        $this.removeAttr('alt')
      }
      let imgSrc = wwjs.ui.loadImg()
      if (this.hasAttribute(dataLoadingImg)) {
        let img = $this.attr(dataLoadingImg) || ''
        img = img.trim()
        if (img) {
          if (img === 'none') {
            imgSrc = false
          } else {
            imgSrc = img
          }
        }
        $this.removeAttr(dataLoadingImg)
      }
      if (imgSrc) {
        $this.attr('src', imgSrc)
      }
      $this.addClass('lazyload')
    }
  })
}

function proc ({ $content, $tplContent, buildInfo }) {
  return Promise.pipe([
    function () {
      return procElement($content, buildInfo)
    },
    function () {
      return procElement($tplContent, buildInfo)
    }
  ])
}

export default proc
